import React from 'react';

/**
 * Station Tickets
 * @returns {any} The result
 */
function StationTickets() {
  return <div>StationTickets</div>;
}

export default StationTickets;
